// Sticker set shown in the bottom tray and usable as map markers.
export const TRAY_STICKERS = [
  '📍', '🗽', '🏙️', '🗼', '☕', '🍜', '⛩️', '🍔', '🎡', '🏖️',
  '🥞', '👟', '🧁', '🎃', '✈️', '🍩', '🌮', '🎸', '🏯', '🚲',
]

export const DEFAULT_STICKER = '📍'
